const sentryConfig = {
  dsn: "https://fd718325cde14ccebd0833f62e104399@o234395.ingest.sentry.io/5757378",
  tracesSampleRate: 0,
  environment: "dev",
  release: "c031acea785cd058803c35266dacdaaf4af4ed8d-Ubuntu7Standard:37a63b0e-26b2-4794-b58e-1ca204da9d25",
};

export default sentryConfig;
